<template>
  <div>
    <loadingSpan v-if='loading' fix>加载中...</loadingSpan>
    <div class="Info">
      <div class="title">{{this.$route.meta.menuTitle}}</div>
    </div>
    <div class="content">
      <div class="tableArea">
        <lk-table :columns='columns' :data='tableData' border ></lk-table>
      </div>
    </div>
  </div>
</template>
<script>
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import healthInsManage from '../../services/healthInsManage';
import loadingSpan from '../../components/LoadingSpan.vue'

export default {
  name: 'pharmacistCode',
  mixins: [mapState],
  components: {
    loadingSpan,
  },
  computed: {},
  data() {
    return {
      loading: false,
      tempMedListCodg: '',  // 暂存onchange事件的值，防止每输入一次就失焦
      tableData: [],
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
        },
        {
          title: '药师ID',
          key: 'id',
          minWidth: 116,
        },
        {
          title: '药师名称',
          key: 'name',
          minWidth: 116,
        },
        {
          title: '医保药师编码',
          key: 'medListCodg',
          minWidth: 116,
          tooltip: true,
          render: (h, { row, index }) => row.isModify ? h('lk-input', {
            on: {
              'on-change': (e) => {
                if (e.target.value === '') {
                  this.tempMedListCodg = 0;  // 0表示是手动修改的空，不是没有出发change事件的空
                } else {
                  this.tempMedListCodg = e.target.value;
                }
              },
            },
            props: {
              value: row.medListCodg,
            },
          }) : h('span', row.medListCodg)
        },
        {
          title: '操作',
          minWidth: 26,
          render: (h, { row, index }) => h('lk-button',{
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  if (!row.isModify) {
                    this.tempMedListCodg = '';
                    this.$nextTick(() => {
                      this.tableData.forEach((item, idx) => {
                        if (idx === index) {
                          item.isModify = true;
                        } else {
                          item.isModify = false;
                        }
                      })
                    })
                  } else {
                    const { id } = this.tableData[index];
                    const params = {  // 修改药师编码入参
                      userId: id,
                    };
                    this.handlerUpdateMedListCodg(params, index);
                  }
                },
              },
            }, row.isModify ? '保存' : '修改'),
        },
      ],
    };
  },
  methods: {
    getDate() {
      const params = {
        roleId: 3,
      }
      healthInsManage.getByRole(params).then((res) => {
        this.loading = true;
        if (res.data.status === 200) {
          this.loading = false;
          if (res.data.data && res.data.data instanceof Array) {
            let tempArray = res.data.data;
            tempArray.forEach(item => {
              this.$set(item, 'isModify', false); // 操作栏是修改还是保存
            });
            this.tableData = tempArray;
            this.tempMedListCodg = '';
          }
        } else {
          this.loading = false;
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.loading = false;
        utils.handleError(err);
      })
    },
    handlerUpdateMedListCodg(params, index) {  //修改药师编码
      if (this.tempMedListCodg === 0) {  // 判断是否是输入的空
        params.medListCodg = '';
      } else {
        params.medListCodg = this.tempMedListCodg === '' ? this.tableData[index].medListCodg : this.tempMedListCodg;
      }
      healthInsManage.updateMedListCodg(params).then((res) => {
        this.loading = true;
        if (res.data.status === 200) {
          this.loading = false;
        } else {
          this.loading = false;
          this.$Message.error(res.data.error);
        }
        this.getDate();
      }).catch((err) => {
        this.loading = false;
        utils.handleError(err);
      })
    },
  },
  created() {
  },
  mounted() {
    this.getDate();
  }
};
</script>
<style lang="less" scoped>
  .Info {
    background-color: #fff;
    height: 60px;
    padding: 10px 0 5px 15px;
    .title {
      font-family: regular;
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 5px;
      color:#515a6e;
    }
  }
  .content {
    background-color: #fff;
    margin: 15px 0 0 10px;
    padding: 15px 15px 20px 15px;
    .pageTool {
      margin-top: 20px;
      display: flex;
      flex-direction: row-reverse;
    }
  }
</style>
